import { useCallback, useLayoutEffect } from 'react';

import { useAppSelector } from '../../store';
import { selectActiveWidgets } from '../../store/widgetSelector';
import { useFocus } from './useFocus';

/**
 *  Handles global focus events in the editor
 */
export const Focus = () => {
  const activeWidgets = useAppSelector(selectActiveWidgets);
  const { setWidgetFocus } = useFocus();

  // If a widget becomes active => set focus on widget
  const onSetWidgetFocus = useCallback(() => {
    if (activeWidgets && activeWidgets.length === 1) setWidgetFocus(activeWidgets[0].id);
  }, [activeWidgets, setWidgetFocus]);

  // Layout effect required set focus after the widget ref has been set / updated
  useLayoutEffect(onSetWidgetFocus, [onSetWidgetFocus]);

  return <></>;
};
